module.exports = __webpack_public_path__ + "img/fant-farm-03.78d8ee0c.jpg";